import {Component, HostListener, OnInit} from '@angular/core';
import {CommonModule, formatDate} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowUp,
  faChartSimple,
  faCircleExclamation,
  faCircleXmark,
  faEye,
  faFileExcel,
  faMagnifyingGlass,
  faSearchMinus,
  faSearchPlus,
  faSquarePollVertical,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import {ApiService} from '../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {getFileNameFromResponse} from '../../common/utils';
import saveAs from 'file-saver';
import {AuthService} from '../services/auth.service';
import {DatePickerModule} from 'primeng/datepicker';
import {GenericSearchComponent} from '../shared/search-suggestion/search-suggestion.component';
import {ImageViewerComponent} from '../shared/image-viewer/image-viewer.component';
import {VehicleNumberCopyDirective} from '../shared/vehicle-number-copy/vehicle-number-copy.directive';
import {displayCameraEsn} from '../shared/camera-display';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../shared/constants/pagination.constants';


interface Reports {
  match: boolean;
  vehicleNo: string;
  date: string;
  time: string;
  direction: string;
  vehicleImage: string;
}

interface ReportData {
  is_match: boolean;
  vehicle_number: string;
  created_at: string;
  // time: string;
  direction: string;
  camera_esn?: string;
  camera_esn_display?: string;
  entry_camera_esn?: string;
  exit_camera_esn?: string;
  full_image_path: string;
  vehicle_image_url: string;
}

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.css'],
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule, FormsModule,
        DatePickerModule, GenericSearchComponent, ImageViewerComponent, VehicleNumberCopyDirective]
})
export class ReportsComponent implements OnInit{
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;
  vehicleNumber: string = '';
  searchText: string = '';
  reports: Reports[] = [];
  recordsPerPage: number = 10;
  currentPage: number = 1;
  generateReports: Reports[] = [];
  showTable: boolean = false;
  noRecords:boolean = false;
  selectedImages: { url: string; direction: string }[] = [];
  showModal: boolean = false;
  
  genarateReportFrom: FormGroup;
  reportData: ReportData[] = [];
  nextPage: number | null = null;
  previousPage: number | null = null;
  totalRecords: number = 0;
  camera_esn = [];
  today:Date = new Date();
  rawData: any;
  hoveredColumn = '';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  


  
  constructor(private  router: Router, 
    library: FaIconLibrary, 
    fb:FormBuilder,
    public apiService: ApiService,
    private authService: AuthService,
    private toastr: ToastrService,
  ) {
    library.addIcons(faTrash,
      faFileExcel,
      faAngleRight,
      faAngleLeft,
      faEye,
      faCircleXmark,
      faChartSimple,
      faCircleExclamation,
      faSquarePollVertical,
      faMagnifyingGlass,
        faSearchPlus, faSearchMinus, faArrowUp, faArrowDown
  )

    this.genarateReportFrom = fb.group({
      // fromDate: [new Date().toISOString().substring(0, 10), Validators.required],
      // toDate: [new Date().toISOString().substring(0, 10), Validators.required],
      fromDate: [this.today, Validators.required],
      toDate:  [this.today, Validators.required],
      searchText: [''],
      dashboardFilter: [''],
      directionFilter: [''],
      exportToExcel: ['']
    })
    this.camera_esn = this.authService.getCurrentUserInfo()['camera_esn']
  }

  ngOnInit() {
  const data = history.state;
  if (data && data.from_date && data.to_date && data.from_dashboard) {
  const dashboardFilter = data.dashboard_filter || '';
  const isDirection = dashboardFilter === 'Entry' || dashboardFilter === 'Exit';
  this.genarateReportFrom.patchValue({
    fromDate: new Date(data.from_date),
    toDate: new Date(data.to_date),
    dashboardFilter: isDirection ? '' : dashboardFilter,
    directionFilter: isDirection ? dashboardFilter : ''
  });
  this.generateReport(this.currentPage, this.recordsPerPage, true);
  }
}
  get paginatedRecords(): Reports[] {
    const start = (this.currentPage - 1) * this.recordsPerPage;
    const end = start + this.recordsPerPage;
    return this.generateReports.slice(start, end);
  }

  get totalPages(): number {
    let totalPage = Math.ceil(this.totalRecords / this.recordsPerPage);
    if (totalPage === 0){
      totalPage = 1;
    }
    return totalPage;
  }

  displayCameraEsn(record: ReportData): string {
    return displayCameraEsn(record);
  }

  generateReport(page: number, pageSize: number, preserveStatus: boolean = false) {
    
    if (this.genarateReportFrom.valid) {
      if (!preserveStatus) {
        this.genarateReportFrom.patchValue({ dashboardFilter: '' }, { emitEvent: false });
      }
      const fromDate = formatDate(this.genarateReportFrom.value.fromDate.toISOString(), 'yyyy-MM-dd', 'en-IN');
      const toDate = formatDate(this.genarateReportFrom.value.toDate.toISOString(), 'yyyy-MM-dd', 'en-IN');
     
      this.rawData = {
        "from_date":  fromDate,
        "to_date":   toDate,
        'camera_esn': this.camera_esn,
      }
        if (this.searchText) {
        this.rawData.search_text = this.searchText;
      }
      const statusFilter = this.genarateReportFrom.value.dashboardFilter || this.genarateReportFrom.value.directionFilter;
      if (statusFilter){
        this.rawData.dashboard_filter = statusFilter
      }
      if (this.sortColumn) {
        this.rawData.sort_column = this.sortDirection === 'desc' ? `-${this.sortColumn}` : this.sortColumn;
      }

      this.apiService.generateReport(page, pageSize, this.rawData).subscribe({
          next: (response:any) => {
            this.reportData = response['results'];
            this.nextPage = response['next']
            this.previousPage = response['previous']
            this.totalRecords = response['count']
            if (this.totalRecords !== 0){
              this.showTable = true;
              this.noRecords = false;
            }else if (this.genarateReportFrom.value.searchText){
              this.showTable = true;
              this.noRecords = false;
            }
            else{
              this.showTable = false;
              this.noRecords = true;

            }
          },
          error: (err) => {
            if (err['error']['non_field_errors']) {
              err['error']['non_field_errors'].forEach((element:any) => {
                this.toastr.error(element);
              });
            } else if (err['status'] !== 403 && err.status !== 0) {
              this.toastr.error("Something went wrong!", 'Error');
            }
          }
        });
    }
  }

  searchVehicles(pageSize: number) {
    this.currentPage = 1;
    this.generateReport(this.currentPage, pageSize, true)
  }

  deleteVehicle(vehicleNo: string) {
    this.reports = this.reports.filter(vehicle => vehicle.vehicleNo !== vehicleNo);
    this.generateReports = this.generateReports.filter(vehicle => vehicle.vehicleNo !== vehicleNo);
  }
  // changePage(page: number) {
  //   if (page > 0 && page <= this.totalPages) {
  //     this.currentPage = page;
  //   }
  // }
  next() {
    if (this.nextPage){
      this.currentPage++;
      this.generateReport(this.currentPage, this.recordsPerPage, true)
    }
  }

  previous() {
    if (this.previousPage){
      this.currentPage--;
      this.generateReport(this.currentPage, this.recordsPerPage, true)
      }
  }
  selectPageSize(){
    if(this.recordsPerPage){
      // debugger;
      this.currentPage = 1;
      this.generateReport(this.currentPage, this.recordsPerPage, true)
    }
  }

  onStatusChange() {
    this.currentPage = 1;
    if (this.genarateReportFrom.value.dashboardFilter) {
      this.genarateReportFrom.patchValue({ directionFilter: '' }, { emitEvent: false });
    }
    this.generateReport(this.currentPage, this.recordsPerPage, true);
  }

  onDirectionChange() {
    this.currentPage = 1;
    if (this.genarateReportFrom.value.directionFilter) {
      this.genarateReportFrom.patchValue({ dashboardFilter: '' }, { emitEvent: false });
    }
    this.generateReport(this.currentPage, this.recordsPerPage, true);
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.currentPage = 1;
    this.generateReport(this.currentPage, this.recordsPerPage, true);
  }
  viewImage(imageUrl: string, direction: string): void {
    const formattedDirection =
    direction.charAt(0).toUpperCase() + direction.slice(1).toLowerCase();

    this.selectedImages = [];
    if (imageUrl) {
      this.selectedImages.push({ url: imageUrl, direction: formattedDirection });
    }
    this.showModal = true;
  }




  closeModal = () => {
  this.showModal = false;
  };

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const modalElement = document.querySelector('.modal-content');
    if (modalElement && !modalElement.contains(target)) {
      this.showModal = false;
    }
  }

  exportToExcel() {
    let rawData = {
      'from_date': formatDate(this.genarateReportFrom.value.fromDate.toISOString(), 'yyyy-MM-dd', 'en-IN'),
      'to_date': formatDate(this.genarateReportFrom.value.toDate.toISOString(), 'yyyy-MM-dd', 'en-IN') ,
      'export_to_excel': true,
      'search_text': this.searchText,
      'camera_esn': this.camera_esn
    }
    
    this.apiService.exportReport(rawData).subscribe({
        next: (response:any) => {
          const fileName = getFileNameFromResponse(response);
            if (response.body) {
                saveAs(response.body, fileName);
            }
        },
        error: (err) => {
          this.toastr.error(`${err}`)
        }
      });
  }

onResults(event: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
  this.currentPage = 1;
  this.recordsPerPage = 10;
  this.previousPage = event.previousPage;
  this.nextPage = event.nextPage;
  this.searchText = event.searchText;
  this.reportData = event.results;
  this.totalRecords = event.totalRecords;
}
          
}
